import React, { PropsWithChildren } from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import Button from './Button';
import ButtonPrimary from './ButtonPrimary';
import { useTranslation } from 'react-i18next';

interface ButtonLinkProps {
  disabled?: boolean;
  className?: string;
}

const ButtonQuickPurchase = ({
  disabled = false,
  className,

}: PropsWithChildren<ButtonLinkProps>) => {

  const { isQuickPurchase, setIsQuickPurchase, isAuthenticatedBySSO, hasQuickPurchase, isAuthenticatedToQuickPurchase, showButtonQuickPurchase } = useLoginContext();
  const { t } = useTranslation();

  if (!hasQuickPurchase || isAuthenticatedToQuickPurchase || !showButtonQuickPurchase) return null;

  return (
    (isAuthenticatedBySSO || isQuickPurchase) ? (
      <Button 
        onClick={() => setIsQuickPurchase(!isQuickPurchase)}
        disabled={disabled}
        className={`${className}`}
      >
        {isQuickPurchase ? t('login.already_registered_title') : t('login.quick_purchase_title')}
    </Button>
    ) : (
      <ButtonPrimary 
        outline
        onClick={() => setIsQuickPurchase(!isQuickPurchase)}
        disabled={disabled}
        className={`${className}`}
      >
        {isQuickPurchase ? t('login.already_registered_title') : t('login.quick_purchase_title')}
    </ButtonPrimary>
    )
  )
}

export default ButtonQuickPurchase;